import BD_Question from "@bd-components/bd-question";
import Store_Sequences from "@bd-components/store-sequences";
import bdapi from "@bd-core/bd-api";
import BD_GAME_LOGIC from "@bd-core/game-logic";
import $ from "jquery";

export class QuestionOpenField extends BD_Question {
  constructor(...args) {
    super(...args);

    this.elms = {
      inputText: ".open_field__input",
      inputTextContainer: ".open_field__container",
      submitBtn: ".open_field_submit",
      continueBtn: ".open_field_continue",
      closeWrongFeedbackBtn: ".close-wrong-feedback",
    };

    this.correctAnswer = 0;
    this.hasSubmitAnswer = false;
    this.answerIds = [];

    this.setContinueButtonState();
  }

  setContinueButtonState() {
    const questionData = this.questionData;
    const minimumAnswer =
      questionData.meta_data.minimum_answer_to_continue ?? 0;
    const isEnable = this.correctAnswer >= minimumAnswer;

    if (isEnable) {
      this.enableContinueButton();
    } else {
      this.disableContinueButton();
    }
  }

  getEvents() {
    const elms = this.elms;
    return [
      {
        event: "focus",
        selector: elms.inputText,
        handler: this.onInputFieldFocus.bind(this),
        isQuestionEvent: true,
      },
      {
        event: "click",
        selector: elms.submitBtn,
        handler: this.submitAnswer.bind(this),
        isQuestionEvent: true,
      },
      {
        event: "click",
        selector: elms.continueBtn,
        handler: this.onContinue.bind(this),
        isQuestionEvent: true,
      },
      {
        event: "click",
        selector: elms.closeWrongFeedbackBtn,
        handler: this.onInputFieldFocus.bind(this),
        isQuestionEvent: true,
      },
    ];
  }

  getAnswer() {
    return this.answerIds;
  }

  submitAnswer() {
    const $submitBtn = $(this.elms.submitBtn);
    if ($submitBtn.hasClass("is-loading")) {
      return;
    }
    $submitBtn.addClass("is-loading");

    const answer = $(this.elms.inputText).val();
    if (!answer) {
      $submitBtn.removeClass("is-loading");
      return;
    }

    const stringPurify = answer
      .toString()
      .replace(/[.,/#!$%^&*;:{}=\-_`~()]/g, "");
    const stringArr = stringPurify.split(" ");
    const questionData = this.questionData;
    const questionAnswers = questionData.answers;
    let correctAnswers = [];
    let correctAnswerIds = [];

    const $existingAnswers = $(".slot__answer.is-correct");
    if ($existingAnswers.length) {
      $existingAnswers.each(function () {
        const answer = $(this).text();
        correctAnswers.push(answer);
      });
    }

    let isCorrectAnswerExist = false;
    stringArr.forEach(function (item) {
      const isCorrect = questionAnswers.find(function (answer) {
        return answer.text.toLowerCase() === item.toLowerCase();
      });

      if (isCorrect && !correctAnswers.includes(item)) {
        correctAnswers.push(item);
        correctAnswerIds.push(isCorrect.id);
        isCorrectAnswerExist = true;
      }
    });

    // support phrase
    const isCorrectPhrase = questionAnswers.find(function (answer) {
      return answer.text.toLowerCase() === stringPurify.toLowerCase();
    });

    if (isCorrectPhrase && !correctAnswers.includes(stringPurify)) {
      correctAnswers.push(stringPurify);
      correctAnswerIds.push(isCorrectPhrase.id);
      isCorrectAnswerExist = true;
    }

    if (correctAnswers.length) {
      this.showCorrectAnswers(correctAnswers);
    }

    try {
      if (
        correctAnswers.length >=
        (questionData.meta_data.minimum_answer_to_continue ?? 0)
      ) {
        this.onCompleteAnswer();
        this.enableContinueButton();
        this.hasSubmitAnswer = true;
        this.answerIds = correctAnswerIds;

        bdapi
          .post("game/submit-answer", {
            current_block: BD_GAME_LOGIC.getCurrentBlockID(),
            answer_data: this.answerIds,
          })
          .then(() => {})
          .catch(() => {});
      } else if (!isCorrectAnswerExist) {
        this.onWrongAnswer();
      }
    } catch (e) {
      console.error(e);
    } finally {
      $submitBtn.removeClass("is-loading");
    }
  }

  onContinue() {
    const sequenceData =
      Store_Sequences.data?.[BD_GAME_LOGIC.getCurrentBlockID()];
    const nextSeqId = sequenceData.next.default ?? 0;
    BD_GAME_LOGIC.goTo(nextSeqId);
  }

  onInputFieldFocus() {
    $(this.elms.inputTextContainer)
      .addClass("is-active")
      .removeClass("is-incorrect is-complete");
  }

  onWrongAnswer() {
    $(this.elms.inputTextContainer)
      .addClass("is-incorrect")
      .removeClass("is-active is-complete");
    setTimeout(() => {
      this.onInputFieldFocus();
    }, 5000);
  }

  onCompleteAnswer() {
    $(this.elms.inputTextContainer)
      .addClass("is-complete")
      .removeClass("is-active is-incorrect");
    $(this.elms.submitBtn).attr("disabled", "disabled");
  }

  enableContinueButton() {
    $(this.elms.continueBtn).removeAttr("disabled");
  }

  disableContinueButton() {
    $(this.elms.continueBtn).attr("disabled", "disabled");
  }

  showCorrectAnswers(items) {
    const $slotTemplate = $(".slot-template").first();
    if (!$slotTemplate.length) {
      return;
    }

    const questionData = this.questionData;
    const minimumAnswer =
      questionData.meta_data.minimum_answer_to_continue ?? 0;
    const $answerWrapper = $(".open_field__slots");
    $answerWrapper.html("");
    items.forEach((item) => {
      const $slotClone = $slotTemplate.clone();
      const $slotAnswer = $slotClone.find(".slot__answer");
      $answerWrapper.append($slotClone);
      $slotAnswer.text(item);
      $slotAnswer.addClass("is-correct");
      $slotClone.show();
    });

    if (items.length < minimumAnswer) {
      const diff = minimumAnswer - items.length;
      for (let i = 0; i < diff; i++) {
        $answerWrapper.append('<div class="slot"></div>');
      }
    }
  }
}
